import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'


const ChangeAssessments = ({ productId = null, hideAddButton = null, hideBreadcrumbs = null }) => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});


    let defaultFilters = null;
    if (productId) {
        defaultFilters = [{ key: "products", value: productId }];
    }


    const rowStyleProcessor = (value) => {

        if (!value) return "";

        const date = new Date(value);
        const today = new Date();

        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        if (date < today) {
            return "datatable-row-red";
        }

        const daysUntilDue = Math.ceil(
            (date - today) / (1000 * 60 * 60 * 24)
        );

        if (daysUntilDue <= 30) {
            return "datatable-row-yellow";
        }

        return "";
    };

    let config = {};

    config.dataUrl = "/umbraco/api/RIMSRegistrations/ChangeAssessments";
    config.getSingleItemUrl = "/umbraco/api/RIMSRegistrations/ChangeAssessment";
    config.pageTitle = "Change Assessments";
    config.singleItemTitle = "Change Assessment";
    config.entityType = "change-assessments";
    config.entityTypeId = 12;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.pageIcon = "fas fa-clipboard-check";
    config.breadcrumbs = [{ "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" }, { "Name": "Change Assessments", "Link": "/your-medboard/country-registrations/change-assessments/" }]
    config.dataStructure = [];
    config.deleteUrl = "/umbraco/api/RIMSRegistrations/BulkChangeAssessments/?changeIds=";
    config.showDeleteButton = true;
    config.preLoadItemUrlParamName = "changeId";
    config.defaultOrderByField = "Title";
    config.preLoadItemId = window.preloadChangeId;
    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/RIMSRegistrations/ChangeAssessmentsCount/";
    config.rowStyleProcessor = rowStyleProcessor;
    config.rowStyleProcessorColumn = "ExpiryDate";
    config.showTaskCount = false;
    config.hideAddButton = hideAddButton ? hideAddButton : false;
    config.hideBreadcrumbs = hideBreadcrumbs ? hideBreadcrumbs : false;
    config.enableCustomFields = true;

    useEffect(() => {
        loadStructure();
    }, []);

    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {

                    let renderComponent = FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text;

                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: renderComponent,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                    });
                });

                // ==========================================
                // 5. REORDER COLUMNS: Action Required next to Progress
                // ==========================================
                const actionReqIndex = config.dataStructure.findIndex(col => col.field === "ActionRequiredCount");

                if (actionReqIndex > -1) {
                    // Temporarily remove the Action Required column from the array
                    const [actionReqCol] = config.dataStructure.splice(actionReqIndex, 1);

                    // Find where the Progress column is currently located
                    const progressIndex = config.dataStructure.findIndex(col => col.field === "Progress" || col.name === "Progress");

                    if (progressIndex > -1) {
                        // Insert the Action Required column immediately after Progress
                        config.dataStructure.splice(progressIndex + 1, 0, actionReqCol);
                    } else {
                        // Fallback: If no Progress column exists, put it back at the end
                        config.dataStructure.push(actionReqCol);
                    }
                }

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    return (<>
        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
            {isLoadingStructure ? <>
                <LoadingSpinnerImage />
            </> : <>
                <DataTable dataTableStructure={dataTableStructure}
                    ItemDetailsPane={ItemDetailsPane}
                    AddItemPopup={AddItemPopup}
                    ReloadStructureFunction={loadStructure} 
                    defaultFilters={defaultFilters} />
            </>}
        </>}
    </>);
};

export default ChangeAssessments;